/* eslint-disable prettier/prettier */
export enum AppRoute {
  Index = '/dashboard',
  DashboardComponent = '/dashboard/homepage',
  TwoFactor = '/dashboard/pinauth',
  ActiveMailing = '/dashboard/homepage/activemailing',
}
